import React from 'react';
import {
    Row,
    Col,
    Alert
} from 'reactstrap';
import { useTranslation } from 'react-i18next';

const StepSeven = ({ jumpToStep }) => {
    const { t } = useTranslation();

    return (
        <div className="step step7 mt-5">
            <Row className="justify-content-md-center">
                <Col lg="6">
                    <Alert color="info">
                        {t("userDataForm.view.stepSeven.form.message.approval")}
                    </Alert>
                </Col>
            </Row>
        </div>
    );
};

export default StepSeven;